import { useState, useEffect } from 'react';
import { fetchBusinessFeaturePermissions } from '../utils/businessPermissions';

export function useSiteTerminology() {
  const [useSite, setUseSite] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetchBusinessFeaturePermissions()
      .then((perms) => setUseSite(perms.useSiteTerminology))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return { useSite, loaded };
}
